import { createActions, handleActions } from 'redux-actions'

export const LOGOUT_SUCCESS = 'authentication/LOGOUT_SUCCESS'

export const FETCH_COURSES = 'levelUp/FETCH_COURSES'
export const FETCH_COURSES_FAILURE = 'levelUp/FETCH_COURSES_FAILURE'
export const FETCH_COURSES_SUCCESS = 'levelUp/FETCH_COURSES_SUCCESS'

export const FETCH_COURSE_CATEGORIES = 'levelUp/FETCH_COURSE_CATEGORIES'
export const FETCH_COURSE_CATEGORIES_FAILURE = 'levelUp/FETCH_COURSE_CATEGORIES_FAILURE'
export const FETCH_COURSE_CATEGORIES_SUCCESS = 'levelUp/FETCH_COURSE_CATEGORIES_SUCCESS'

export const FETCH_COURSE_COLLECTIONS = 'levelUp/FETCH_COURSE_COLLECTIONS'
export const FETCH_COURSE_COLLECTIONS_FAILURE = 'levelUp/FETCH_COURSE_COLLECTIONS_FAILURE'
export const FETCH_COURSE_COLLECTIONS_SUCCESS = 'levelUp/FETCH_COURSE_COLLECTIONS_SUCCESS'

export const FETCH_GROWTH_GUIDES = 'levelUp/FETCH_GROWTH_GUIDES'
export const FETCH_GROWTH_GUIDES_FAILURE = 'levelUp/FETCH_GROWTH_GUIDES_FAILURE'
export const FETCH_GROWTH_GUIDES_SUCCESS = 'levelUp/FETCH_GROWTH_GUIDES_SUCCESS'

export const REGISTER_FOR_LEVEL_UP = 'levelUp/REGISTER_FOR_LEVEL_UP'
export const REGISTER_FOR_LEVEL_UP_FAILURE = 'levelUp/REGISTER_FOR_LEVEL_UP_FAILURE'
export const REGISTER_FOR_LEVEL_UP_SUCCESS = 'levelUp/REGISTER_FOR_LEVEL_UP_SUCCESS'

export const {
  levelUp: {
    fetchCourses,
    fetchCoursesFailure,
    fetchCoursesSuccess,
    fetchCourseCategories,
    fetchCourseCategoriesFailure,
    fetchCourseCategoriesSuccess,
    fetchCourseCollections,
    fetchCourseCollectionsFailure,
    fetchCourseCollectionsSuccess,
    fetchGrowthGuides,
    fetchGrowthGuidesFailure,
    fetchGrowthGuidesSuccess,
    registerForLevelUp,
    registerForLevelUpSuccess,
    registerForLevelUpFailure
  }
} = createActions({
  [FETCH_COURSES]: undefined,
  [FETCH_COURSES_FAILURE]: undefined,
  [FETCH_COURSES_SUCCESS]: undefined,
  [FETCH_COURSE_CATEGORIES]: undefined,
  [FETCH_COURSE_CATEGORIES_FAILURE]: undefined,
  [FETCH_COURSE_CATEGORIES_SUCCESS]: undefined,
  [FETCH_COURSE_COLLECTIONS]: undefined,
  [FETCH_COURSE_COLLECTIONS_FAILURE]: undefined,
  [FETCH_COURSE_COLLECTIONS_SUCCESS]: undefined,
  [FETCH_GROWTH_GUIDES]: undefined,
  [FETCH_GROWTH_GUIDES_FAILURE]: undefined,
  [FETCH_GROWTH_GUIDES_SUCCESS]: undefined,
  [REGISTER_FOR_LEVEL_UP]: undefined,
  [REGISTER_FOR_LEVEL_UP_FAILURE]: undefined,
  [REGISTER_FOR_LEVEL_UP_SUCCESS]: undefined
})

const initialState = {
  courseCategories: [],
  courseCollections: [],
  courses: [],
  courseGuides: [],
  errorMessage: null,
  isError: false,
  isLoading: false,
  isSubmitting: false,
  isSuccess: false
}

export default handleActions(
  {
    [LOGOUT_SUCCESS]: () => initialState,
    [FETCH_COURSES]: () => ({
      errorMessage: null,
      isLoading: false,
      isError: false,
      isSuccess: false,
      isSubmitting: true
    }),
    [FETCH_COURSES_FAILURE]: () => ({
      errorMessage: null,
      isSubmitting: false,
      isLoading: false,
      isSuccess: false,
      isError: true
    }),
    [FETCH_COURSES_SUCCESS]: (state, { payload }) => ({
      ...state,
      courses: payload,
      isLoading: false,
      isSubmitting: false,
      isSuccess: true,
      isError: false
    }),
    [FETCH_COURSE_CATEGORIES]: () => ({
      errorMessage: null,
      isLoading: false,
      isError: false,
      isSuccess: false,
      isSubmitting: true
    }),
    [FETCH_COURSE_CATEGORIES_FAILURE]: () => ({
      errorMessage: null,
      isSubmitting: false,
      isLoading: false,
      isSuccess: false,
      isError: true
    }),
    [FETCH_COURSE_CATEGORIES_SUCCESS]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.data.result,
      payload: payload,
      isLoading: false,
      isSubmitting: false,
      isSuccess: payload.data.success,
      isError: !payload.data.success
    }),
    [FETCH_COURSE_COLLECTIONS]: () => ({
      errorMessage: null,
      isLoading: false,
      isError: false,
      isSuccess: false,
      isSubmitting: true
    }),
    [FETCH_COURSE_COLLECTIONS_FAILURE]: () => ({
      errorMessage: null,
      isSubmitting: false,
      isLoading: false,
      isSuccess: false,
      isError: true
    }),
    [FETCH_COURSE_COLLECTIONS_SUCCESS]: (state, { payload }) => ({
      ...state,
      courseCollections: payload,
      isLoading: false,
      isSubmitting: false,
      isSuccess: true,
      isError: false
    }),
    [FETCH_GROWTH_GUIDES]: () => ({
      errorMessage: null,
      isLoading: false,
      isError: false,
      isSuccess: false,
      isSubmitting: true
    }),
    [FETCH_GROWTH_GUIDES_FAILURE]: () => ({
      errorMessage: null,
      isSubmitting: false,
      isLoading: false,
      isSuccess: false,
      isError: true
    }),
    [FETCH_GROWTH_GUIDES_SUCCESS]: (state, { payload }) => ({
      ...state,
      courseGuides: payload,
      isLoading: false,
      isSubmitting: false,
      isSuccess: true,
      isError: false
    }),
    [REGISTER_FOR_LEVEL_UP]: () => ({
      errorMessage: null,
      isLoading: false,
      isError: false,
      isSuccess: false,
      isSubmitting: true
    }),
    [REGISTER_FOR_LEVEL_UP_FAILURE]: () => ({
      errorMessage: null,
      isSubmitting: false,
      isLoading: false,
      isSuccess: false,
      isError: true
    }),
    [REGISTER_FOR_LEVEL_UP_SUCCESS]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.data.result,
      payload: payload,
      isLoading: false,
      isSubmitting: false,
      isSuccess: payload.data.success,
      isError: !payload.data.success
    })
  },
  initialState
)
